import { render } from "./Informationurl.vue?vue&type=template&id=76147bbe"
import script from "./Informationurl.vue?vue&type=script&lang=js"
export * from "./Informationurl.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\toru-ota\\source\\repos\\Marron\\Jarvis\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__